import styled from "styled-components";
import {
  BORDER_RADIUS,
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  SIZE,
} from "constants/variables";
import { PersonnelCardType } from "./PersonnelCardModel";

export const PersonnelCardContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: ${BORDER_RADIUS.radius32};
  display: flex;
  align-items: stretch;
`;

export const PersonnelCardImage = styled.img<{ type: PersonnelCardType }>`
  height: ${({ type }) =>
    type === PersonnelCardType.Adaptable ? "100%" : SIZE.max550};
  width: ${({ type }) =>
    type === PersonnelCardType.Adaptable ? "100%" : SIZE.max380};
  background-color: ${COLORS.Cultured};
  object-fit: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PersonnelCardTextContainer = styled.div`
  position: absolute;
  bottom: 14px;
  left: 14px;
  right: 14px;
  background-color: ${COLORS.RaisinBlack};
  border-radius: ${BORDER_RADIUS.radius24};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${SIZE.max18} ${SIZE.max10};
  gap: 4px;
  @media (width<=768px) {
    bottom: 12px;
    left: 12px;
    right: 12px;
  }
`;

export const TitleWrapper = styled.div`
  text-align: center;
`;

export const TextWrapper = styled.p`
  text-align: center;
  color: ${COLORS.MetalicSilver};
  font-family: ${FONT_FAMILY.poppins};
  font-weight: ${FONT_WEIGHT.regular};
  font-size: ${({ accessibilityBiggerText }) =>
    !accessibilityBiggerText ? FONT_SIZE.fix14 : FONT_SIZE.fix16};
  line-height: ${({ accessibilityBiggerLineHeight }) =>
    !accessibilityBiggerLineHeight ? 1.3 : 1.6};
  letter-spacing: ${({ accessibilityBiggerLetterSpacing }) =>
    !accessibilityBiggerLetterSpacing ? 0 : "1px"};
`;
